import React from "react";
import Blog_50_9 from "../component/Blog_50_9";
function Blog_50_9_container() {
  return <Blog_50_9 />;
}

export default Blog_50_9_container;
